import React from "react";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { TiHome } from "react-icons/ti";
import { AiOutlineLogout } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";

const Dashboardsidenav = () => {
  const navigate = useNavigate(); // Use the useNavigate hook

  const handleLogout = () => {
    // Clear user data from localStorage
    localStorage.removeItem("userdata");

    // Navigate to the login page
    navigate("/");
  };

  return (
    <div className="h-[400px] bg-[#000043] w-[118px] gap-20 grid place-content-center rounded-md">
      <div>
        <Link to="/dashboard">
          <TiHome className=" text-[#fff] text-[40px]" />
        </Link>
      </div>
      <div>
        <Link to="/transaction">
          <LiaFileInvoiceDollarSolid className=" text-[#fff] text-[40px]" />
        </Link>
      </div>
      <div>
        <button
         onClick={handleLogout}
         >
          <AiOutlineLogout className=" text-[#fff] text-[40px]" />
        </button>
      </div>
    </div>
  );
};

export default Dashboardsidenav;
